import React from "react";

function DsCarousel(props) {
  let carouselIntervalId;
  let l_int_currentImageId;

  document.documentElement.classList.remove("nav-open");

  React.useEffect(() => {
      // eslint-disable-next-line no-unused-vars
      let isMounted = true;

      //startCustomCarousel(bannersCount);
  
      // Cleanup function
      return () => {
        isMounted = false;
        stopCustomCarousel()
      }
    });

 /**
 * customRendering
 * @returns 
 */
 const carouselRendering = () => {
  let pictures_story_board = null;

  if (!((props.pictures_list != null) && (props.pictures_list.length > 0))){
      return (<img
        //id = "home-video"
        width="100%"
        height="100%"
        src_old="https://i.vimeocdn.com/video/1449210825-79d671233bc3780a6c12c0ec819f752bbb44b392a88dd4ff734bf58794cec5ce-d?mw=3400&mh=1913&q=70"
        src={props.fallback_picture}
    />);
  }

  pictures_story_board = props.pictures_list.map((pictureItem,ii)=>{
      return  (
                  <img id={`${props.dom_image_prefix}-${ii}`} key={pictureItem.data_guid}
                       
                      alt={pictureItem.data_blob.data_tier.partner_short_text}
                      className= {(ii==0 || props.show_all)?"custom-carousel-visible":"custom-carousel-hidden"}
                      src={pictureItem.data_blob.data_tier[props.picture_field_name]}
                      width={"100%"}
                  />)
             
          });
  
  if(props.pictures_list.length > 1 && !props.pause)
    startCustomCarousel(props.pictures_list.length);
  
  return pictures_story_board
}    

  /**
   * Prototype : startCustomCarousel
   */
  const startCustomCarousel = (p_int_carousel_images_count) => {
    if (props.debugging)
      console.log("startCustomCarousel")
    // check if an interval has already been set up
    if (!carouselIntervalId) {
      carouselIntervalId = setInterval(rotateCarousel, props.pause_in_second * 1000, p_int_carousel_images_count);
      l_int_currentImageId = 0;
    }
  }

  /**
   * Prototype : stopCustomCarousel
   */
  const stopCustomCarousel = () => {
    clearInterval(carouselIntervalId);
    // release our intervalId from the variable
    carouselIntervalId = null;
  }

  async function setObjectClass(p_obj_id, p_class_name){
    let oElem = await document.getElementById(p_obj_id);
    if(oElem) oElem.className = p_class_name;
  }

  /**
   * Prototype : rotateCarousel
   * @param {*} p_bool_need_carousel_mapping 
   * @param {*} p_partners_list_fetched 
   */
  function rotateCarousel(p_int_carousel_images_count) {
    if (props.debugging)
      console.log(`rotateCarousel : p_int_carousel_images_count-> ${p_int_carousel_images_count} l_int_currentImageId->${l_int_currentImageId}`)
    let l_int_nextImageId = (l_int_currentImageId + 1)%p_int_carousel_images_count;

    //Hide current image first
    setObjectClass(`${props.dom_image_prefix}-${l_int_currentImageId}`, "custom-carousel-hidden");
    
    //Show next image now
    setObjectClass(`${props.dom_image_prefix}-${l_int_nextImageId}`, "custom-carousel-visible");

    //Update new active image id
    l_int_currentImageId = l_int_nextImageId
  }


  return (
    <div className={props.dom_image_class_containter}>
        {carouselRendering()}
    </div>
  );
}

export default DsCarousel;
